import React, { Component } from 'react';
import { Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { isNavKeyboardSelect } from 'context/keyboard';

// Each tab is a destination with its own URL, so it renders as a real anchor carrying that URL.
// react-bootstrap's <Tabs> shorthand cannot do this — it never forwards an href to the NavLink it
// builds, so SafeAnchor substitutes href="#" and preventDefault()s the click, leaving tabs that
// cannot be ⌘-clicked, copied, or opened in a new tab. See docs/specs/2026-07-25-tab-anchors.md.
export default class BlobTabs extends Component {
  renderIcon(descriptor) {
    if (!descriptor.icon) return null;
    const Icon = descriptor.icon;
    return <Icon/>;
  }

  // A disabled tab has no destination, so it renders as a <span> and gets no anchor at all.
  renderLink(descriptor, className) {
    const body = <>{this.renderIcon(descriptor)} {descriptor.title}</>;
    if (descriptor.disabled) {
      return (
        <Nav.Link
          key={descriptor.key}
          eventKey={descriptor.key}
          role="tab"
          className={className}
          as="span"
          disabled
        >{body}</Nav.Link>
      );
    }
    return (
      <Nav.Link
        key={descriptor.key}
        eventKey={descriptor.key}
        role="tab"
        className={className}
        as={Link}
        to={descriptor.to}
      >{body}</Nav.Link>
    );
  }

  visibleDescriptors() {
    return this.props.descriptors.filter(d => !d.hidden);
  }

  // The tabs navigate themselves, so this component owns no navigation — except for arrow-key
  // traversal, which react-bootstrap performs on the strip rather than on a link and only reports
  // through onSelect. The reached tab goes back to the page, which holds the history.
  handleKeyboardTraverse = (key, event) => {
    if (!isNavKeyboardSelect(event)) return;
    if (!this.props.onKeyboardTraverse) return;
    const descriptor = this.visibleDescriptors().find(d => d.key === key);
    if (descriptor) this.props.onKeyboardTraverse(descriptor);
  };

  // Mirrors the DOM react-bootstrap's <Tabs> produced: the anchor itself carries .nav-item.
  renderExpanded() {
    return (
      <Container className="blob-header-row main-tabs">
        <Nav
          variant="tabs"
          as="nav"
          role="tablist"
          activeKey={this.props.activeKey}
          onSelect={this.handleKeyboardTraverse}
        >
          {this.visibleDescriptors().map(d => this.renderLink(d, "nav-item"))}
        </Nav>
      </Container>
    );
  }

  // The compact strip keeps its <Nav.Item> wrappers — .main-tabs.compact .nav-item styles them as
  // the flex children of the strip (pages/Blob/index.css).
  renderCompact() {
    return (
      <Nav
        className="main-tabs compact"
        role="tablist"
        activeKey={this.props.activeKey}
        onSelect={this.handleKeyboardTraverse}
      >
        {this.visibleDescriptors().map(d => (
          <Nav.Item key={d.key}>{this.renderLink(d)}</Nav.Item>
        ))}
      </Nav>
    );
  }

  render() {
    return this.props.compact ? this.renderCompact() : this.renderExpanded();
  }
}
